import { MILLISECONDS_PER_SECOND } from './constants';

export class TokenManager {
  static #instance: TokenManager | null = null;
  #accessToken = localStorage.getItem('access_token');
  #refreshToken = localStorage.getItem('refresh_token');
  #accessTokenExpires = Number(
    localStorage.getItem('access_token_expires')
  );
  #deviceAttested = Boolean(
    localStorage.getItem('device_attested')
  );

  private constructor() {
    TokenManager.#instance = this;
  }

  public clear() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token_expires');
    localStorage.removeItem('token_manager_references');
  }

  public static get instance() {
    return TokenManager.#instance ?? new TokenManager();
  }

  public get accessToken() {
    return this.#accessToken;
  }

  public setAccessToken(accessToken: string, expires: number) {
    this.#accessToken = accessToken;
    this.#accessTokenExpires = expires;
    localStorage.setItem('access_token', this.#accessToken);
    localStorage.setItem('access_token_expires', String(this.#accessTokenExpires));
    return this;
  }

  public get accessTokenExpired() {
    return Date.now() >= (this.#accessTokenExpires * MILLISECONDS_PER_SECOND);
  }

  public get refreshToken() {
    if (this.accessTokenExpired)
      return this.#refreshToken;
    return null;
  }

  public setRefreshToken(refreshToken?: string) {
    this.#refreshToken = refreshToken ?? null;
    if (!this.#refreshToken)
      return localStorage.removeItem('refresh_token');  
    localStorage.setItem('refresh_token', this.#refreshToken);
  }

  public get deviceAttested() {
    return this.#deviceAttested;
  }

  public setDeviceAttested(deviceAttested: boolean) {
    this.#deviceAttested = deviceAttested;
    localStorage.setItem('device_attested', String(this.#deviceAttested));
    return this;
  }
}